var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$store.state.loading && _vm.view == "grid" && !_vm.$store.state.mobile
      ? _c(
          "div",
          [
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                staticClass: "gridLoader",
                attrs: {
                  width: 235,
                  height: 400,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "192",
                    rx: "0",
                    ry: "0",
                    width: "215",
                    height: "16",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "220",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "239",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "256",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "275",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "17",
                    y: "296",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "15",
                    y: "30",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "144",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "16",
                    y: "334",
                    rx: "0",
                    ry: "0",
                    width: "214",
                    height: "30",
                  },
                }),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.$store.state.loading && _vm.$store.state.mobile
      ? _c(
          "div",
          [
            _c(
              "content-loader",
              {
                attrs: {
                  width: 345,
                  height: 600,
                  speed: 0.5,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "471",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "53",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "24",
                    rx: "0",
                    ry: "0",
                    width: "306",
                    height: "17",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "336",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "355",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "372",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "13",
                    y: "391",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "12",
                    y: "414",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "52",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "18",
                    y: "81",
                    rx: "0",
                    ry: "0",
                    width: "282",
                    height: "189",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "154",
                    y: "92",
                    rx: "0",
                    ry: "0",
                    width: "2",
                    height: "1",
                  },
                }),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.$store.state.loading && !_vm.$store.state.mobile && _vm.view == "list"
      ? _c(
          "div",
          [
            _c(
              "content-loader",
              {
                attrs: {
                  width: 600,
                  height: 254,
                  speed: 2,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "172",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "24",
                    rx: "0",
                    ry: "0",
                    width: "306",
                    height: "17",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "60",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "79",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "96",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "115",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "138",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                attrs: {
                  width: 600,
                  height: 254,
                  speed: 2,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "172",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "24",
                    rx: "0",
                    ry: "0",
                    width: "306",
                    height: "17",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "60",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "79",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "96",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "115",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "138",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                attrs: {
                  width: 600,
                  height: 254,
                  speed: 2,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "172",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "24",
                    rx: "0",
                    ry: "0",
                    width: "306",
                    height: "17",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "60",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "79",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "96",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "115",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "138",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
              ]
            ),
            _c(
              "content-loader",
              {
                attrs: {
                  width: 600,
                  height: 254,
                  speed: 2,
                  primaryColor: "#d6d6d6",
                  secondaryColor: "#ecebeb",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "354",
                    y: "23",
                    rx: "0",
                    ry: "0",
                    width: "251",
                    height: "167",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "172",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "24",
                    rx: "0",
                    ry: "0",
                    width: "306",
                    height: "17",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "60",
                    rx: "0",
                    ry: "0",
                    width: "198",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "79",
                    rx: "0",
                    ry: "0",
                    width: "273",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "96",
                    rx: "0",
                    ry: "0",
                    width: "150",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "9",
                    y: "115",
                    rx: "0",
                    ry: "0",
                    width: "180",
                    height: "9",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "8",
                    y: "138",
                    rx: "0",
                    ry: "0",
                    width: "311",
                    height: "27",
                  },
                }),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }